import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import InfiniteScroll from "react-infinite-scroll-component";
import { Redirect } from 'react-router-dom'
import LoadingImage from "../../../comum/components/LoadingImage";
import Footer from "../../../comum/components/Footer";
import paginationFactory from 'react-bootstrap-table2-paginator';
import { Row, Col, Button, Container } from 'reactstrap';
import { Link } from "react-router-dom";
import ModalAviso from "../../../comum/components/ModalAviso";
import ModalForm from "../../../comum/components/ModalForm";
import { IconeProibido, IconeEditar, IconeLiberar, IconeLista, IconeAtencao, IconeNaoMsgLida, IconeCheck } from "../../../comum/components/Icones";
import CardAgendamento from "./CardAgendamento";
import { buscaSemResultado, buscaFiltrarVazio } from '../../../../utils/mensagens';
import FooterContent from "../../../comum/components/FooterContent";
import { HeaderTableFixed } from "../../../../utils/headerTableFixed";
import { CollapseItemTableIndicator } from "../../../comum/components/CollapseItemTableIndicator";
import DetalheAgendamento from "./DetalheAgendamento"
import lscache from "lscache";
import FormInputSimples from "../../../comum/components/FormInputSimples";

@inject("store")
@observer
export class TabelaAgendamento extends Component {

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
        this.loginStore = this.props.store.loginStore;

        this.controller = this.props.controller;

        this.addAcoesCol();
        window.addEventListener('scroll', HeaderTableFixed);
    }

    can = (operacao = "C", tarefa = "AgendamentoContainer") => this.loginStore.can(tarefa, operacao)

    addAcoesCol() {
        const InternoExterno = lscache.get('InternoExterno');
        const statusCanLibEsp = ["P", "V", "C"];
        const fainaDepot = [90,91];
        this.controller.colunas.push({
            dataField: 'acoes',
            isDummyField: true,
            text: '',
            formatter: (cell, row) => {
                return <div>
                    {this.can("LM") &&
                        (["PD"].indexOf(row.CodStatus) > -1)
                        && InternoExterno.includes('I') && <a onClick={() => this.controller.setIdLiberacaoManual(row.AgendId)} >
                            <IconeCheck title={"Liberação Manual"} tamanho="lg" className="m-2" />
                        </a>
                    }&nbsp;
                    {this.can() && (["PD"].indexOf(row.CodStatus) === -1) &&
                        <a onClick={() => 
                            !this.controller.loading ? this.controller.carregarAgendamentoResumo(row.AgendId, row.DscTipo, row.StatusAgendamento): null 
                        } >
                          <IconeLista title={"Resumos"} tamanho="lg" className="m-2" />
                        </a> 
                    }&nbsp;
                    {this.can("A") &&
                        (["I"].indexOf(row.CodStatus) > -1)
                        && <a onClick={() => this.controller.setIdAgendamentoIncompleto(row.AgendId)} >
                            <IconeAtencao title={"Agendamento Incompleto"} tamanho="lg" className="m-2" />
                        </a> 
                    }&nbsp;
                    {this.can("A") &&
                        (["I", "P", "L"].indexOf(row.CodStatus) > -1)
                        && <a onClick={() => this.controller.setIdRow(row.AgendId)} >
                            <IconeProibido title={"Cancelar"} tamanho="lg" className="m-2" />
                        </a>
                    }&nbsp;
                    {this.can("A") &&
                        (["PD"].indexOf(row.CodStatus) > -1)
                        && <a onClick={() => this.controller.setIdCancelarDepot(row.AgendId)} >
                            <IconeProibido title={"Cancelar Depot"} tamanho="lg" className="m-2" />
                        </a>
                    }&nbsp;
                    {this.can("LB") &&
                        (["R", "T"].indexOf(row.CodStatus) > -1)
                        && <a onClick={() => this.controller.setIdRow(row.AgendId)} >
                            <IconeProibido title={"Cancelar"} tamanho="lg" className="m-2" />
                        </a>
                    }&nbsp;
                    {this.can("A") &&
                        (["I", "P", "PD"].indexOf(row.CodStatus) > -1)
                        && <a onClick={() => this.controller.verificarEdicaoAgendamento(row.AgendId)} >
                            <IconeEditar title={"Editar"} tamanho="lg" className="m-2" />
                        </a> 
                    }&nbsp;
                    {this.can("LB") &&
                        (statusCanLibEsp.indexOf(row.CodStatus) > -1)
                        && InternoExterno.includes('I') && <a onClick={() => this.controller.setIdLiberacao(row.AgendId)} >
                            <IconeLiberar title={"Liberação especial"} tamanho="lg" className="m-2" />
                        </a> 
                    }&nbsp;
                    {this.can("LD") &&
                        (statusCanLibEsp.indexOf(row.CodStatus) > -1)
                        && (fainaDepot.indexOf(row.FainaId) > -1)
                        && InternoExterno.includes('I') && <a onClick={() => this.controller.setIdLiberacao(row.AgendId)} >
                            <IconeLiberar title={"Liberação especial"} tamanho="lg" className="m-2" />
                        </a> 
                    }&nbsp;
                    {this.can("A") &&
                        ["P", "I", "L", "A"].indexOf(row.CodStatus) > -1 &&
                        <a onClick={() => this.controller.setIdReenvioBat(row.AgendId)} >
                            <IconeNaoMsgLida title={"Reenviar Bat Eletrônica"} tamanho="lg" className="m-2" />
                        </a>
                    }
                </div>
            },
            cardFormatter: (cell, row) => {
                return <Row>
                    <Col sm={12}>
                        {this.can("A") &&
                            (["I", "P", "L"].indexOf(row.CodStatus) > -1)
                            && <Button className="btn-com-bordas-primary" onClick={() => this.controller.setIdRow(row.AgendId)} >Cancelar</Button>
                        }
                        {this.can("A") &&
                            (["I", "P"].indexOf(row.CodStatus) > -1)
                            && <Link to={`agendamento-container/cadastro/${row.AgendId}`}>
                                <Button className="btn-com-bordas-primary" to={`agendamento-container/cadastro/${row.AgendId}`} >Editar</Button>
                            </Link>
                        }
                        {this.can("LibEspecial") &&
                            (statusCanLibEsp.indexOf(row.CodStatus) > -1)
                            && <Button className="btn-com-bordas-primary" onClick={() => this.controller.setIdLiberacao(row.AgendId)} >Liberação</Button>
                        }
                        {this.can("LM") &&
                            (["PD"].indexOf(row.CodStatus) > -1)
                            && <Button className="btn-com-bordas-primary" onClick={() => this.controller.setIdLiberacaoManual(row.AgendId)} >Liberação Manual</Button>
                        }
                    </Col>
                </Row>
            }
        });
    }

    liberacaoEspecial = () => 
    {
        return (
            <div> 
                <h2 className="ml-3 mr-3">Deseja realmente realizar a Liberação Especial?</h2>
                <FormInputSimples 
                    titulo="Observação" xs={12} sm={12} md={12} lg={12} xl={12}
                    limiteMaximo={4000}
                    type="textarea"
                    onChange={(event) => { this.controller.obsLiberacaoEspecial = event.target.value.toUpperCase() }} />
            </div>
        )
    }

    liberacaoManualDepot = () => 
    {
        return (
            <div> 
                <h2 className="ml-3 mr-3">Deseja realmente realizar a Liberação Manual deste Agendamento?</h2>
                <FormInputSimples 
                    titulo="Observação" xs={12} sm={12} md={12} lg={12} xl={12}
                    limiteMaximo={4000}
                    type="textarea"
                    onChange={(event) => { this.controller.obsLiberacaoEspecial = event.target.value.toUpperCase() }} />
            </div>
        )
    }

    cancelarDepot = () => 
    {
        return (
            <div> 
                <h2 className="ml-3 mr-3">Deseja realmente cancelar este Agendamento com status Pendente?</h2>
                <FormInputSimples 
                    titulo="Motivo" xs={12} sm={12} md={12} lg={12} xl={12}
                    limiteMaximo={4000}
                    type="textarea"
                    onChange={(event) => { this.controller.obsLiberacaoEspecial = event.target.value.toUpperCase() }} />
            </div>
        )
    }

    modalConfirmaCancelar = () => {
        if (this.controller.modalCancelar)
            return (
            <ModalForm labelCancelar="NÃO"
                labelConfirmar="SIM"
                salvando={this.controller.liberacaoLoading}
                onClickCancelar={() => this.controller.fechaModais()}
                onClickSalvar={() => this.controller.confirmarAcao()}>
                {this.controller.modalCancelar === "CANCELAR" && <h2>Deseja realmente cancelar o Agendamento?</h2>}
                {this.controller.modalCancelar === "LIBERAR" && this.liberacaoEspecial()}
                {this.controller.modalCancelar === "LIBERARMANUAL" && this.liberacaoManualDepot()}
                {this.controller.modalCancelar === "CANCELARDEPOT" && this.cancelarDepot()}
                {this.controller.modalCancelar === "REENVIAR_BAT" && <h2>Deseja realmente reenviar a Bat Eletrônica?</h2>}
            </ModalForm>)
    };

    modalExibirMensagem = () => {
        if (this.controller.modalMensagem)
            if (this.controller.modalMensagem === "RESUMO") {
                return <ModalAviso
                    onClickFechar={() => this.controller.fechaModais()}>
                    {this.controller.modalMensagem === "RESUMO" && <h2>Recurso em desenvolvimento. Aguarde uma nova atualização!</h2>}
                </ModalAviso>
            }
            else if (this.controller.modalMensagem === "INCOMPLETO") {
                return <ModalAviso
                    onClickFechar={() => this.controller.fechaModais()}>
                    {this.mensagensIncompleto(this.controller.modalMensagem, this.controller.pendenciasAgendamento)}
                </ModalAviso>
            }
    };

    mensagensIncompleto = (modal, msg) => {

        if (modal === "INCOMPLETO") {
            return <h2>{msg}</h2>
        }
    }

    modalEditarAgendamento = () => {
        if (this.controller.modalEditarAgendamento) {
            if (!this.controller.loading) {

                if (this.controller.edicaoAgendamento) {
                    return <Redirect to={`agendamento-container/cadastro/${this.controller.edicaoAgendamento}`} />
                } else {
                    return <ModalAviso onClickFechar={() => this.controller.fechaModais()}>
                        <h2>{this.controller.mensagemEdicaoAgendamento}</h2>
                    </ModalAviso>
                }

            } else {
                return <ModalAviso onClickFechar={() => this.controller.fechaModais()}>
                    <h2><LoadingImage /></h2>
                </ModalAviso>
            }
        }
    };

    modalResposta = () => {
        if (this.controller.responseAcao)
            return <ModalAviso onClickFechar={() => this.controller.fechaModais()}>
                <h2>{this.controller.responseAcao}</h2>
            </ModalAviso>
    };

    renderDados = (detalhesRow) => {
        let loading = this.controller.loading;

        return (
            <Container fluid className="tabela-container">
                {(!this.controller.filtrado)
                    ?
                    <Row>
                        <Col className="mt-3" xs={12}>
                            <span className="mensagem-filtrar">
                                {buscaFiltrarVazio}
                            </span>
                        </Col>
                    </Row>
                    :
                    <InfiniteScroll
                        dataLength={this.controller.itens.length}
                        next={() => this.controller.loadNextTurn()}
                        hasMore={this.controller.hasMore}
                        loader={<LoadingImage />}
                    >
                        <ToolkitProvider
                            keyField="AgendId"
                            data={[...this.controller.itens]}
                            columns={[...this.controller.colunas]}
                        >
                            {props => (
                                <div>
                                    {window.innerWidth > 991 ?

                                        <div id="tableHeaderFixed" className="tabela-overflow">
                                            <BootstrapTable bootstrap4
                                                /*wrapperClasses="table-responsive"*/
                                                striped
                                                bordered={false}
                                                expandRow={detalhesRow}
                                                noDataIndication={() => loading ?
                                                    <LoadingImage /> : this.controller.tableMessage}
                                                classes="tabela tabela-layout agendamento"
                                                //pagination={ paginationFactory() }
                                                {...props.baseProps}
                                            />
                                        </div>
                                        :
                                        <Row>
                                            {loading ?
                                                <LoadingImage />
                                                :
                                                (this.controller.itens.length > 0 ?
                                                    this.controller.itens.map((card, x) => (
                                                        <CardAgendamento
                                                            key={x}
                                                            data={card}
                                                            id={x}
                                                            colunas={[...this.controller.colunas]}
                                                            cancelAction={this.controller.setIdRow}
                                                        // capacidade={[...this.controller.capacidade]}
                                                        // containerAgendados={[...this.controller.containerAgendados]}
                                                        // titulo="booking.Nbr"
                                                        />
                                                    ))
                                                    :
                                                    <Col className="mt-3" xs={12}>
                                                        <span className="mensagem-filtrar">
                                                            {buscaSemResultado}
                                                        </span>
                                                    </Col>
                                                )
                                            }
                                        </Row>
                                    }
                                </div>)
                            }
                        </ToolkitProvider>
                    </InfiniteScroll>
                }
                <Footer>
                    <FooterContent>
                        {this.controller.total !== null && <div className="justify-content-between">
                            <div><b>{this.controller.itens.length}</b> Registros no Total - <a
                                onClick={() => this.controller.carregarLista()}>Atualizar Lista</a>
                            </div>
                            {this.modalConfirmaCancelar()}
                            {this.modalResposta()}
                            {this.modalExibirMensagem()}
                            {this.modalEditarAgendamento()}
                        </div>}
                    </FooterContent>

                </Footer>

            </Container>
        );
    }

    render() {
        const detalhesRow = {
           
            renderer: row => (

                <Row>
                    <DetalheAgendamento titulo="Detalhes" colunas={this.controller.colunas} row={row} controller={this.controller}/>
                </Row>
                
            ),
            showExpandColumn: true,
            expandByColumnOnly: true,
            expandHeaderColumnRenderer: () => "Detalhes",
            onExpandAll: (isExpandAll, results, e) => {
                e.PreventDefault();
            },
            expandColumnPosition: 'right',
            expandColumnRenderer: ({ expanded }) => {
                console.log("indificar: " , expanded)
                return (
                    <CollapseItemTableIndicator expanded={expanded} />
                );
            }
        };

        return <React.Fragment>
            {this.controller.carregandoLista && <LoadingImage />}
            {this.controller.atualiza && this.renderDados(detalhesRow)}
        </React.Fragment>
    }
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-visualizar/components/TabelaAgendamento.js